import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getMarginBottomClass, marginBottomLevels } from '../../utils/marginBottom/index.js';
import styles from './spinner.css.js';

var Spinner = function Spinner(_ref) {
  var _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 0 : _ref$marginBottom;
  return React.createElement("div", {
    className: cn(styles.Spinner, getMarginBottomClass(marginBottom))
  }, React.createElement("div", {
    className: styles.spinnerLayer
  }, React.createElement("div", {
    className: cn(styles.circleClipper, styles.left)
  }, React.createElement("div", {
    className: styles.circle
  })), React.createElement("div", {
    className: styles.gapPatch
  }, React.createElement("div", {
    className: styles.circle
  })), React.createElement("div", {
    className: cn(styles.circleClipper, styles.right)
  }, React.createElement("div", {
    className: styles.circle
  }))));
};

Spinner.displayName = 'Spinner';
Spinner.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
export default Spinner;
export { Spinner };